/**
 * Mockup v3 P3 (Organización): the strings of Personas, Equipos, Invitaciones and Plataforma >
 * Organizaciones. Spread into `es` by `es.ts`; P3 adds its keys here only.
 *
 * The copy is the v3 mockup's (`mockup-ux-redesign-v3.html`), minus what needs e-mail (P2 is out of
 * scope): no "Reenviar", and invitations are shared by copying their link.
 */
export const esOrganization = {
  // Roles (labels only: the server decides what each role may do).
  "organization.role.orgAdmin": "Admin de organización",
  "organization.role.orgMember": "Miembro",
  "organization.role.teamLead": "Líder de equipo",
  "organization.role.teamMember": "Miembro de equipo",
  "organization.teamRole.lead": "Líder",
  "organization.teamRole.member": "Miembro",

  // Shared pieces.
  "organization.target.label": "Organización",
  "organization.you": "(tú)",
  "organization.actions": "Acciones",
  "organization.saving": "Guardando…",

  // Personas.
  "organization.people.title": "Personas",
  "organization.people.intro": "Quién forma parte de la organización y con qué rol.",
  "organization.people.search": "Buscar personas",
  "organization.people.searchPlaceholder": "Buscar por nombre o correo",
  "organization.people.count": "{people} personas · {admins} admins",
  "organization.people.column.person": "Persona",
  "organization.people.column.role": "Rol",
  "organization.people.column.teams": "Equipos",
  "organization.people.noTeam": "Sin equipo",
  "organization.people.leadSuffix": "· líder",
  "organization.people.roleOf": "Rol de {name}",
  "organization.people.ownRole": "No puedes cambiar tu propio rol",
  "organization.people.menuFor": "Acciones para {name}",
  "organization.people.menu.remove": "Quitar de la organización",
  "organization.people.loading": "Cargando las personas…",
  "organization.people.empty.title": "Todavía no hay nadie más",
  "organization.people.empty.body": "Invita a tu equipo para diseñar juntos.",
  "organization.people.noMatch.title": "Nadie coincide con la búsqueda",
  "organization.people.noMatch.body": "Prueba con otra parte del nombre o del correo.",
  "organization.people.confirmRole.title": "¿Cambiar el rol?",
  "organization.people.confirmRole.body": "{name} pasará a ser {role}.",
  "organization.people.confirmRole.confirm": "Cambiar rol",
  "organization.people.roleChanged": "Rol actualizado.",
  "organization.remove.title": "¿Quitar a {name} de la organización?",
  "organization.remove.body": "Dejará de poder entrar en la organización y saldrá de sus equipos. Su cuenta no se borra.",
  // Owner 2026-10-19: only the people who can receive every one of the person's mockups are offered.
  "organization.remove.recipient": "Reasignar sus {count} mockups a…",
  "organization.remove.recipientHelp": "Se reasignan antes de quitarle el acceso, para que nadie pierda trabajo. Solo aparece quien tiene acceso a todos ellos.",
  "organization.remove.confirm": "Reasignar y quitar",
  "organization.remove.confirmPlain": "Quitar",
  "organization.remove.loading": "Buscando quién puede recibir sus mockups…",
  "organization.remove.nothing": "No tiene mockups de la organización a su nombre.",
  "organization.remove.stillOwns": "Mientras tanto se le asignaron mockups de la organización: elige quién los recibe.",
  "organization.remove.nobody": "Nadie de la organización puede recibir sus mockups: solo puede recibirlos quien tenga acceso a todos los equipos donde están. Añade a alguien a esos equipos o nómbralo admin, y vuelve a intentarlo.",
  "organization.remove.done": "Persona quitada de la organización.",

  // Invitaciones.
  "organization.invitations.title": "Invitaciones",
  "organization.invitations.intro": "Invita a personas que se unen a la organización.",
  "organization.invitations.invite": "Invitar personas",
  "organization.invitations.tabs": "Estado",
  "organization.invitations.tab.pending": "Pendientes",
  "organization.invitations.tab.all": "Todas",
  "organization.invitations.notice": "Comparte cada invitación con su enlace. Copiar enlace te da un enlace nuevo y anula el anterior.",
  "organization.invitations.column.email": "Correo",
  "organization.invitations.column.role": "Rol",
  "organization.invitations.column.team": "Equipo",
  "organization.invitations.column.status": "Estado",
  "organization.invitations.column.expires": "Caducidad",
  "organization.invitations.status.pending": "Pendiente",
  "organization.invitations.status.expired": "Caducada",
  "organization.invitations.status.consumed": "Usada o revocada",
  "organization.invitations.expiresOn": "Caduca el {date}",
  "organization.invitations.expiredOn": "Caducó el {date}",
  "organization.invitations.copyFor": "Copiar un enlace nuevo para {email}",
  "organization.invitations.copyTitle": "Copiar enlace (anula el anterior)",
  "organization.invitations.copied": "Enlace nuevo copiado. El anterior ya no sirve.",
  "organization.invitations.copyFailed": "No se pudo copiar. Copia el enlace nuevo aquí:",
  "organization.invitations.linkFor": "Enlace de invitación para {email}",
  "organization.invitations.revoke": "Revocar",
  "organization.invitations.revoke.title": "¿Revocar la invitación?",
  "organization.invitations.revoke.body": "El enlace de {email} dejará de servir. Podrás invitar de nuevo cuando quieras.",
  "organization.invitations.replacesLead": "Líder (reemplaza a {name})",
  "organization.invitations.replacesLeadUnknown": "Líder (reemplaza al líder anterior)",
  "organization.invitations.revoked": "Invitación revocada.",
  "organization.invitations.loading": "Cargando las invitaciones…",
  "organization.invitations.empty.title": "No hay invitaciones pendientes",
  "organization.invitations.empty.body": "Invita a alguien y verás aquí su invitación hasta que la use o caduque.",
  "organization.invite.title": "Invitar personas",
  "organization.invite.emails": "Correos",
  "organization.invite.emailsPlaceholder": "nombre@empresa.pe, otra.persona@empresa.pe",
  "organization.invite.emailsHelp": "Uno o varios, separados por comas o saltos de línea.",
  "organization.invite.role": "Rol",
  "organization.invite.team": "Equipo",
  "organization.invite.noTeam": "Sin equipo",
  "organization.invite.teamHelp": "Elige un rol de equipo para asignarlo.",
  "organization.invite.submit": "Crear invitaciones",
  "organization.invite.noEmails": "Escribe al menos un correo.",
  "organization.invite.badEmails": "Revisa estos correos: {emails}",
  "organization.invite.teamRequired": "Elige el equipo al que se une.",
  "organization.invite.partial": "No se pudo invitar a {email}: {message}",
  "organization.invite.leadTaken": "El líder del equipo cambió mientras invitabas. Vuelve a invitar para elegir qué hacer.",
  // Owner 2026-10-19: inviting a lead to a team that has one asks first; the switch happens on acceptance.
  "organization.invite.leadTaken.body": "Si continúas, quien reciba la invitación será líder del equipo al aceptarla, y {name} pasará a ser miembro.",
  "organization.invite.leadPending": "Este equipo ya tiene una invitación de líder pendiente. Revócala para invitar a otro líder.",
  "organization.issued.title": "Invitaciones creadas",
  "organization.issued.body": "Copia cada enlace y envíalo a su persona. Solo se muestra ahora.",
  "organization.issued.emailed": "Enviamos la invitación por correo a {email}.",
  "organization.issued.copy": "Copiar",
  "organization.issued.done": "Listo",

  // Equipos.
  "organization.teams.title": "Equipos",
  "organization.teams.intro": "Grupos de personas que comparten mockups, diseño y presupuesto.",
  "organization.teams.leadIntro": "Los equipos que lideras.",
  "organization.teams.new": "Nuevo equipo",
  "organization.teams.members": "{count} personas",
  "organization.teams.oneMember": "1 persona",
  "organization.teams.lead": "Líder: {name}",
  "organization.teams.noLead": "Sin líder",
  "organization.teams.loading": "Cargando los equipos…",
  "organization.teams.empty.title": "Todavía no hay equipos",
  "organization.teams.empty.body": "Un equipo agrupa personas que comparten mockups, diseño y presupuesto.",
  "organization.teams.nameLabel": "Nombre del equipo",
  "organization.teams.create": "Crear equipo",
  "organization.teams.rename": "Renombrar",
  "organization.teams.renameTitle": "Renombrar el equipo",
  "organization.teams.save": "Guardar",
  "organization.teams.delete": "Eliminar",
  "organization.teams.delete.title": "¿Eliminar el equipo {name}?",
  "organization.teams.delete.body": "Las personas siguen en la organización. No se puede deshacer.",
  "organization.teams.delete.confirm": "Eliminar equipo",
  "organization.team.notFound.title": "No encontramos este equipo",
  "organization.team.notFound.body": "Puede que se haya eliminado o que no tengas acceso.",
  "organization.team.back": "Ver los equipos",
  "organization.team.membersTitle": "Miembros",
  "organization.team.leadNote": "El líder ve el consumo del equipo",
  "organization.team.column.person": "Persona",
  "organization.team.column.role": "Rol en el equipo",
  "organization.team.roleOf": "Rol de {name} en {team}",
  "organization.team.remove": "Quitar",
  "organization.team.removeFor": "Quitar a {name} del equipo",
  "organization.team.noMembers.title": "Este equipo no tiene miembros",
  "organization.team.noMembers.body": "Añade a alguien de la organización con el selector de abajo.",
  "organization.team.add.person": "Añadir persona",
  "organization.team.add.role": "Rol en el equipo",
  "organization.team.add.submit": "Añadir",
  "organization.team.add.option": "{name} · {email}",
  // Owner 2026-10-19: one leader per team (P3-3); the person chooses before the lead changes hands.
  "organization.team.leadTaken.title": "Este equipo ya tiene líder ({name})",
  "organization.team.leadTaken.body": "Si continúas, {person} será el líder del equipo y {name} pasará a ser miembro.",
  "organization.team.leadTaken.convert": "Convertir a {name} en miembro",

  // Name dialog validation (teams and organizations: 1..120 characters).
  "organization.name.required": "Escribe un nombre.",
  "organization.name.tooLong": "Usa como máximo 120 caracteres.",

  // Plataforma > Organizaciones.
  "organization.platform.title": "Organizaciones",
  "organization.platform.intro": "Todas las organizaciones de la plataforma.",
  "organization.platform.create": "Crear organización",
  "organization.platform.createTitle": "Crear organización",
  "organization.platform.nameLabel": "Nombre de la organización",
  "organization.platform.createSubmit": "Crear",
  "organization.platform.renameTitle": "Renombrar la organización",
  "organization.platform.tabs": "Estado",
  "organization.platform.tab.all": "Todas",
  "organization.platform.tab.active": "Activas",
  "organization.platform.tab.suspended": "Suspendidas",
  "organization.platform.column.name": "Nombre",
  "organization.platform.column.status": "Estado",
  "organization.platform.column.people": "Personas",
  "organization.platform.column.spend": "Consumo del mes",
  "organization.platform.column.created": "Creada",
  "organization.platform.status.active": "Activa",
  "organization.platform.status.suspended": "Suspendida",
  "organization.platform.menuFor": "Acciones para {name}",
  "organization.platform.rename": "Renombrar",
  "organization.platform.suspend": "Suspender",
  "organization.platform.reactivate": "Reactivar",
  "organization.platform.suspend.title": "¿Suspender {name}?",
  "organization.platform.suspend.body": "Sus {count} personas no podrán entrar ni generar, y sus enlaces compartidos dejarán de funcionar hasta que la reactives. No se borra nada.",
  "organization.platform.reactivate.title": "¿Reactivar {name}?",
  "organization.platform.reactivate.body": "Sus {count} personas podrán volver a entrar y sus enlaces vuelven a funcionar.",
  "organization.platform.loading": "Cargando las organizaciones…",
  "organization.platform.empty.title": "Todavía no hay organizaciones",
  "organization.platform.empty.body": "Crea la primera para empezar a invitar personas.",
  "organization.platform.emptyFilter.title": "No hay organizaciones en este estado",
  "organization.platform.emptyFilter.body": "Cambia el filtro para ver el resto.",
  // A new organization has nobody in it: the platform admin invites its first admin.
  "organization.platform.inviteAdmin": "Invitar admin",
  "organization.platform.inviteAdmin.title": "Invitar admin",
  "organization.platform.inviteAdmin.organization": "Organización",
  "organization.platform.inviteAdmin.intro": "Quien acepte la invitación será admin de esta organización.",
  "organization.platform.inviteAdmin.email": "Correo",
  "organization.platform.inviteAdmin.placeholder": "nombre@empresa.pe",
  "organization.platform.inviteAdmin.submit": "Enviar invitación",
  "organization.platform.inviteAdmin.required": "Escribe el correo de la persona.",
  "organization.platform.inviteAdmin.invalid": "Escribe un solo correo válido.",

  // `/invitacion/:token`.
  "organization.accept.title": "Únete a tu organización",
  "organization.accept.intro": "Crea tu cuenta para diseñar mockups con tu equipo.",
  "organization.accept.name": "Nombre completo",
  "organization.accept.namePlaceholder": "Como quieres que te vean los demás",
  "organization.accept.password": "Crea tu contraseña",
  "organization.accept.submit": "Unirme",
  "organization.accept.busy": "Creando tu cuenta…",
  "organization.accept.nameRequired": "Escribe tu nombre.",
  "organization.accept.passwordRequired": "Escribe una contraseña.",
  "organization.accept.invalid.title": "Esta invitación ya no es válida",
  "organization.accept.invalid.body": "Caducó, se usó o la revocaron. Pide a quien te invitó una invitación nueva.",
  "organization.accept.login": "Ya tengo cuenta: iniciar sesión",
} as const;
